import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";

import { UtilitySectionData } from "../types";

import UtilityCard from "./UtilityCard";
import Styled from "./index.styles";

export default function UtilityCardListForDesktop({
  data,
  isActiveTarget,
}: {
  data: UtilitySectionData[];
  isActiveTarget: boolean;
}) {
  const { isMobile } = useCheckIsMobile();

  return (
    <Styled.utilityCardList
      className={
        isMobile
          ? `fade-up-animation ${isActiveTarget ? "active" : ""}`
          : undefined
      }
    >
      {data.map((v, index) => (
        <UtilityCard
          key={index}
          data={v}
          sequence={index + 1}
          isActiveTarget={isActiveTarget}
        />
      ))}
    </Styled.utilityCardList>
  );
}
